// Apply staged attachment changes from the editor to a saved entry. Removals
// run before adds. Pure orchestration over the LocalVault attachment API — no
// DOM, no crypto here (putAttachment encrypts the bytes). Never logs bytes.

export async function applyAttachmentOps(vault, entryId, { adds = [], removals = [] } = {}) {
  for (const id of removals) {
    await vault.deleteAttachment(entryId, id);
  }
  for (const a of adds) {
    await vault.putAttachment(entryId, a);
  }
}
